import { all } from 'redux-saga/effects'
import waasSaga from './waas/comp/sagas'

export default function* rootSaga() {
    yield all([
        waasSaga(),
    ])
}
